import React from "react";
import "./EventCard.css";
import { Link } from "react-router-dom";

function EventCard({ id, image, name, date, context }) {
  return (
    <Link to={`/news/${id}`} className="event-link">
      <div className="event-card">
        <div className="event-image-wrapper">
          <img src={image} alt={name} />
        </div>
        <div className="event-content">
          <h3 className="event-title">{name}</h3>
          <p className="event-date">{date}</p>
          <p className="event-context">{context}</p>
        </div>
      </div>
    </Link>
  );
}

export default EventCard;
